// @flow
import http from '@shared/ApiFactory'
import { SM_API_PATH } from '@shared/ApiConfig'

const DISPLAY_LIMIT = 30
const EXPORT_COLUMNS_BY_TAB = {
  phrase_fullsearch: 'Ph,In,Nq,Td,Kd,Cp,Co,Fk,Nr',
  phrase_related: 'Ph,In,Rr,Nq,Td,Kd,Cp,Co,Fk,Nr',
  phrase_questions: 'Ph,In,Nq,Td,Kd,Cp,Co,Nr'
}

const generateSortQuery = ({ columnKey, isAscending }) => {
  const suffix = isAscending ? 'asc' : 'desc'
  const _columnKey = columnKey.toLowerCase()
  return `${_columnKey}_${suffix}`
}

export const getSemrushLoggedInStatusAPI = (siteId: number) =>
  http.GET(`${SM_API_PATH}/sites/${siteId}/semrush/tokens`)

export const logOutSemrushUserAPI = (siteId: number) =>
  http.DELETE(`${SM_API_PATH}/sites/${siteId}/semrush/tokens`)

export const generateSemrushTokensAPI = (code: string, siteId: number) =>
  http.POST(`${SM_API_PATH}/sites/${siteId}/semrush/tokens`, {
    code
  })

export const fetchKeywordsAPI = (
  siteId,
  { phrase, activeTab, database, sortingInfo, dataLength = 0 }
) => {
  const sortQuery = generateSortQuery(sortingInfo)
  const exportColumns = EXPORT_COLUMNS_BY_TAB[activeTab]
  const _database = database.toLowerCase()
  const displayLimit = dataLength + DISPLAY_LIMIT

  const queryString = `phrase=${phrase}&export_columns=${exportColumns}&database=${_database}&display_limit=${displayLimit}&display_offset=${dataLength}&display_sort=${sortQuery}`
  const reqUrl = `${SM_API_PATH}/sites/${siteId}/semrush/query/keywords/${activeTab}?${queryString}`

  return http.GET(reqUrl)
}
